import { render, staticRenderFns } from "./M5.vue?vue&type=template&id=3e401d0b"
import script from "./M5.vue?vue&type=script&lang=js"
export * from "./M5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports